<template>
  <div class="blogpost-card-container">
    <a
      :href="post.url"
      class="blogpost-card"
      :style="{ backgroundImage: `linear-gradient(rgba(19, 19, 19, 0.6) 0%, rgba(19, 19, 19, 0.6) 100%), url(${post.thumbnail_url})`}"
    >
      <div class="blogpost-card__overview font-bold">
        <div class="text-smurfs-gold uppercase">{{post.published_at}} • {{post.author.name}}</div>
        <div class="uppercase mt-1">{{post.title}}</div>
      </div>
      <div class="blogpost-card__details">
        <div class="flex justify-between">
          <span class="font-bold">{{post.published_at}}</span>
          <!--<span>
            <i class="fas fa-comment"></i> 21
          </span>-->
        </div>
        <div class="text-sm leading-sm flex flex-col mt-1">
          <div class="excerpt">{{post.excerpt}}</div>
          <span class="text-right text-smurfs-gold no-underline" href="#">Read more...</span>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    post: Object,
  },
};
</script>

<style>
</style>
